import {
  SECTION_ANNUAL_RETURN_FILE,
  SECTION_ASSOCIATION_DOCUMENTS,
  SECTION_BANK_DETAILS,
  SECTION_BOARD_RESOLUTION,
  SECTION_BUSINESS_LICENSE,
  SECTION_BWA_COMPANY_DOCUMENTS,
  SECTION_BWA_DOCUMENTS,
  SECTION_BWA_GROUP_DOCUMENTS,
  SECTION_CERTIFICATE_OF_INCORPORATION,
  SECTION_CERTIFICATE_OF_REGISTRATION,
  SECTION_CHAMBER_OF_COMMERCE_CERTIFICATE,
  SECTION_COMPANY_DOCUMENTS,
  SECTION_COMPANY_FINANCIALS,
  SECTION_COMPANY_PAN_CARD,
  SECTION_COMPANY_PROFILE,
  SECTION_COMPANY_TRADE_PARTNERS,
  SECTION_COMPANY_UTILITY_BILL,
  SECTION_CREDIT_FACILITIES,
  SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS,
  SECTION_DIRECTOR_LIST,
  SECTION_EXTENDED_DUE_DILIGENCE,
  SECTION_LEGAL_REPRESENTATIVES,
  SECTION_ORGANIZATIONAL_CHART,
  SECTION_PARTNERSHIP_DEED,
  SECTION_REGISTRATION_NUMBERS,
  SECTION_SELLER_TRADE_PARTNERS,
  SECTION_SHARE_HOLDER_LIST,
  SECTION_SUSA,
  SECTION_TAX_NUMBER_CERTIFICATE,
  SECTION_TRADE_REGISTER_EXTRACT,
  SECTION_ULTIMATE_BENEFICIAL_OWNERS,
  SECTION_YEARLY_CLOSING,
  SECTION_YEARLY_CLOSING_COMPANY,
  SECTION_YEARLY_CLOSING_GROUP,
  SECTION_COMPANY_DOCUMENTS_LIST,
  SECTION_COMPANY_FINANCIAL_DOCUMENTS,
  SECTION_INTERMEDIARY_SHAREHOLDERS,
  SECTION_DIRECTORS,
  SECTION_OVERVIEW,
  SECTION_CORPORTATE_REPRESENTATIVES,
  SECTION_PAYMENT_INFORMATION,
  SECTION_DOCUMENTS,
  SECTION_OTHER_DOCUMENTS,
} from './sections'
import {
  ROUTE_COMPANY_DOCUMENTS,
  ROUTE_COMPANY_DOCUMENTS_LIST,
  ROUTE_COMPANY_FINANCIAL_DOCUMENTS,
  ROUTE_COMPANY_PROFILE,
  ROUTE_COMPANY_PROFILE_BANK_DETAILS,
  ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS,
  ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS,
  ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES,
  ROUTE_COMPANY_PROFILE_REGISTRATION_NUMBERS,
  ROUTE_COMPANY_TRADE_PARTNERS,
  ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS,
  ROUTE_COMPANY_PROFILE_DIRECTORS,
  ROUTE_COMPANY_PROFILE_OVERVIEW,
  ROUTE_CORPORATE_REPRESENTATIVES,
  ROUTE_PAYMENT_INFORMATION,
  ROUTE_DOCUMENTS,
  ROUTE_COMPANY_GROUP_FINANCIAL_DOCUMENTS,
  ROUTE_COMPANY_OTHER_DOCUMENTS,
} from '../routes/constants'

export const SECTION_MAP: Record<string, string[]> = {
  [SECTION_COMPANY_PROFILE]: [
    SECTION_OVERVIEW,
    SECTION_SELLER_TRADE_PARTNERS,
    SECTION_REGISTRATION_NUMBERS,
    SECTION_LEGAL_REPRESENTATIVES,
    SECTION_ULTIMATE_BENEFICIAL_OWNERS,
    SECTION_DIRECTORS,
    SECTION_INTERMEDIARY_SHAREHOLDERS,
    SECTION_BANK_DETAILS,
    SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS,
    SECTION_COMPANY_DOCUMENTS_LIST,
    SECTION_COMPANY_FINANCIAL_DOCUMENTS,
  ],
  [SECTION_CORPORTATE_REPRESENTATIVES]: [
    SECTION_LEGAL_REPRESENTATIVES,
    SECTION_ULTIMATE_BENEFICIAL_OWNERS,
    SECTION_DIRECTORS,
  ],
  [SECTION_PAYMENT_INFORMATION]: [SECTION_BANK_DETAILS, SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS],
  [SECTION_DOCUMENTS]: [
    SECTION_COMPANY_DOCUMENTS_LIST,
    SECTION_YEARLY_CLOSING_COMPANY,
    SECTION_YEARLY_CLOSING_GROUP,
    SECTION_OTHER_DOCUMENTS,
  ],
  [SECTION_COMPANY_DOCUMENTS]: [
    SECTION_COMPANY_DOCUMENTS_LIST,
    SECTION_COMPANY_FINANCIAL_DOCUMENTS,
    SECTION_ORGANIZATIONAL_CHART,
    SECTION_CERTIFICATE_OF_INCORPORATION,
    SECTION_ASSOCIATION_DOCUMENTS,
    SECTION_COMPANY_PAN_CARD,
    SECTION_COMPANY_UTILITY_BILL,
    SECTION_PARTNERSHIP_DEED,
    SECTION_CERTIFICATE_OF_REGISTRATION,
    SECTION_BUSINESS_LICENSE,
    SECTION_TRADE_REGISTER_EXTRACT,
    SECTION_ANNUAL_RETURN_FILE,
    SECTION_SHARE_HOLDER_LIST,
    SECTION_TAX_NUMBER_CERTIFICATE,
    SECTION_BOARD_RESOLUTION,
    SECTION_DIRECTOR_LIST,
    SECTION_CHAMBER_OF_COMMERCE_CERTIFICATE,
    SECTION_EXTENDED_DUE_DILIGENCE,
  ],
  [SECTION_COMPANY_FINANCIALS]: [
    SECTION_CREDIT_FACILITIES,
    SECTION_YEARLY_CLOSING,
    SECTION_BWA_DOCUMENTS,
    SECTION_SUSA,
  ],
  [SECTION_YEARLY_CLOSING]: [SECTION_YEARLY_CLOSING_COMPANY, SECTION_YEARLY_CLOSING_GROUP],
  [SECTION_BWA_DOCUMENTS]: [SECTION_BWA_COMPANY_DOCUMENTS, SECTION_BWA_GROUP_DOCUMENTS],
  [SECTION_COMPANY_TRADE_PARTNERS]: [SECTION_SELLER_TRADE_PARTNERS],
}

export const SECTION_ROUTE_MAP: Record<string, string> = {
  [SECTION_BANK_DETAILS]: ROUTE_COMPANY_PROFILE_BANK_DETAILS,
  [SECTION_COMPANY_DOCUMENTS]: ROUTE_COMPANY_DOCUMENTS,
  [SECTION_COMPANY_PROFILE]: ROUTE_COMPANY_PROFILE,
  [SECTION_COMPANY_TRADE_PARTNERS]: ROUTE_COMPANY_TRADE_PARTNERS,
  [SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS]: ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS,
  [SECTION_LEGAL_REPRESENTATIVES]: ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES,
  [SECTION_DIRECTORS]: ROUTE_COMPANY_PROFILE_DIRECTORS,
  [SECTION_REGISTRATION_NUMBERS]: ROUTE_COMPANY_PROFILE_REGISTRATION_NUMBERS,
  [SECTION_SELLER_TRADE_PARTNERS]: ROUTE_COMPANY_TRADE_PARTNERS,
  [SECTION_ULTIMATE_BENEFICIAL_OWNERS]: ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS,
  [SECTION_COMPANY_DOCUMENTS_LIST]: ROUTE_COMPANY_DOCUMENTS_LIST,
  [SECTION_YEARLY_CLOSING_COMPANY]: ROUTE_COMPANY_FINANCIAL_DOCUMENTS,
  [SECTION_INTERMEDIARY_SHAREHOLDERS]: ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS,
  [SECTION_OVERVIEW]: ROUTE_COMPANY_PROFILE_OVERVIEW,
  [SECTION_CORPORTATE_REPRESENTATIVES]: ROUTE_CORPORATE_REPRESENTATIVES,
  [SECTION_PAYMENT_INFORMATION]: ROUTE_PAYMENT_INFORMATION,
  [SECTION_DOCUMENTS]: ROUTE_DOCUMENTS,
  [SECTION_YEARLY_CLOSING_GROUP]: ROUTE_COMPANY_GROUP_FINANCIAL_DOCUMENTS,
  [SECTION_OTHER_DOCUMENTS]: ROUTE_COMPANY_OTHER_DOCUMENTS,
}
